import { ComponentPropsWithoutRef, useState } from 'react';

import FormError from 'dashboard/components/FormControls/FormError';
import FormGroup from 'dashboard/layouts/FormLayout/FormGroup';
import TableLayout, {
  TableActionTD,
  TableNullState,
  TableRemoveRow,
  TableTD,
  TableTH,
  TableTR,
} from 'dashboard/layouts/TableLayout';
import Button from 'design-system/components/Button';
import Input, { InputGroup } from 'design-system/components/Input';

interface ApiAttributesBlocklistProps
  extends Omit<ComponentPropsWithoutRef<'input'>, 'onChange' | 'value'> {
  value?: string[];
  disabled?: boolean;
  error?: string;
  onChange: (values: string[]) => void;
}

export default ({
  value: currentApiAttributes = [],
  disabled,
  error,
  onChange,
}: ApiAttributesBlocklistProps) => {
  const [newApiAttribute, setNewApiAttribute] = useState<string>('');

  const handleRemoveApiAttributes = (idx: number) => {
    onChange([...currentApiAttributes.slice(0, idx), ...currentApiAttributes.slice(idx + 1)]);
  };

  const handleAddApiAttribute = () => {
    onChange([...currentApiAttributes, newApiAttribute]);
    setNewApiAttribute('');
  };

  return (
    <div>
      <TableLayout
        isEmpty={currentApiAttributes.length === 0}
        showHeader={true}
        nullState={
          <TableNullState dataTestBlock='api-attributes-blocklist'>
            <p>No API attributes in blocklist.</p>
          </TableNullState>
        }
        headerTR={
          <>
            <TableTH>Attributes</TableTH>
            <TableTH>{/* Remove domain column */}</TableTH>
          </>
        }
      >
        {currentApiAttributes.map((apiAttribute, idx) => {
          return (
            <TableTR key={idx}>
              <TableTD>{apiAttribute}</TableTD>
              <TableActionTD>
                <TableRemoveRow
                  onClick={() => {
                    handleRemoveApiAttributes(idx);
                  }}
                />
              </TableActionTD>
            </TableTR>
          );
        })}
      </TableLayout>
      <FormGroup>
        <InputGroup
          rightButton={
            <Button
              disabled={disabled}
              onClick={handleAddApiAttribute}
              style={{
                minWidth: '100px',
                width: 'auto',
              }}
              data-test='api-attributes-blocklist__button--add'
            >
              Add
            </Button>
          }
        >
          <Input
            value={newApiAttribute || ''}
            disabled={disabled}
            onChange={(event) => setNewApiAttribute(event.target.value)}
            data-test='api-attributes-blocklist__input--value'
          />
        </InputGroup>
        {!!error && <FormError>{error}</FormError>}
      </FormGroup>
    </div>
  );
};
